import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess, mainChapterListActionId, exhibitionOtherAreaActionId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getGateMasterDetails_action, insertUpdateGateMaster_action } from "../../../../actions/admin_module_action/master_action/gate_master_action";
import Footer from "../../../../common_components/Footer";
import { ThirtyFpsSelect } from "@mui/icons-material";


class GateMasterAU extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            exhibitionList: [],
            chapterList: [],
            selectedChapterList: [],
            is_add: false,
            is_update: false,
            exhibitionID: '',
            gateName: '',
            gateNameErr: '',
            gateID: '',
            zoneList: [{ Zone: '', id: 1, ActionID: 1, GateZoneMappingID: null }],
            IsOtherArea: false,
            ExhibitionOtherAreaID: '',
            ExhibitionOtherAreaList: []
        }

        this.getFillList = this.getFillList.bind(this)
        this.getGateMasterDetails = this.getGateMasterDetails.bind(this)
        this.onBack = this.onBack.bind(this)
        this.insertGateMaster = this.insertGateMaster.bind(this)
        this.updateGateMaster = this.updateGateMaster.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onExhibitionadd = this.onExhibitionadd.bind(this)
        this.handleSegmentSelection = this.handleSegmentSelection.bind(this)

    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '');
        this.getFillList(exhibitionOtherAreaActionId, '', '', '', '', '');
        this.setState({
            is_add: this.props.location.state != null && this.props.location.state.is_add != null ? this.props.location.state.is_add : false,
            is_update: this.props.location.state != null && this.props.location.state.is_update != null ? this.props.location.state.is_update : false,
            gateID: this.props.location.state != null && this.props.location.state.gateID != null ? this.props.location.state.gateID : '',
            exhibitionID: this.props.location.state != null && this.props.location.state.exhibitionID != null ? this.props.location.state.exhibitionID : '',
        }, () => {
            this.state.is_update && this.getGateMasterDetails()

        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === exhibitionActionId) {
                        this.setState({
                            exhibitionList: data.data
                        })
                    }
                    if (actionID === mainChapterListActionId) {
                        this.setState({
                            chapterList: data.data
                        })
                    }
                    if (actionID === exhibitionOtherAreaActionId) {
                        this.setState({
                            ExhibitionOtherAreaList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getGateMasterDetails() {
        this.setState({ isLoading: true })
        const { exhibitionID, gateID, selectedChapterList } = this.state
        this.props.getGateMasterDetails_action(exhibitionID, gateID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, gateName: data.data[0]['GateName'] })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onBack() {
        this.props.navigate('/gateMasterList',)
    }

    insertGateMaster() {
        const { isLoading, exhibitionID, gateName, is_update } = this.state

        if (gateName != '' && gateName != null) {
            this.setState({ isLoading: true })
            this.props.insertUpdateGateMaster_action(gateName)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data)
                        this.setState({ isLoading: false })
                        toastSuccess("added successfully")
                        this.props.navigate('/gateMasterList',)
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            this.setState({ gateNameErr: 'Please enter gate name' })
            toastError("Please enter mandatory fields")
        }
    }

    checkDuplicates(arr, key) {
        const seen = new Set();
        for (let obj of arr) {
            // Ignore if ActionID === 3
            if (obj.ActionID === 3) continue;
            if (seen.has(obj[key])) {
                return false; // duplicate found
            }
            seen.add(obj[key]);
        }
        return true; // no duplicates
    }


    updateGateMaster() {
        const { isLoading, gateName, gateID, is_update } = this.state

        if (gateName != '' && gateName != null && gateID != null && gateID != '') {
            this.setState({ isLoading: true })
            this.props.insertUpdateGateMaster_action(gateName, gateID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data)
                        this.props.navigate('/gateMasterList',)
                        toastSuccess("update successful")
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            this.setState({ gateNameErr: 'Please enter gate name' })
            toastError("Please enter mandatory fields")
        }
    }

    onSave() {
        const { is_update } = this.state;
        if (is_update == true) {
            this.updateGateMaster();
        } else {
            this.insertGateMaster();
        }
    }

    onExhibitionadd(val) {
        this.setState({ exhibitionID: val })
        this.getFillList(mainChapterListActionId, val, '', '', '', '');

    }

    handleSegmentSelection(e) {
        console.log("111111111111111111111", e)
        this.setState({ selectedChapterList: e })
    }

    handleInput(index, e, type) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                if (type == 'checkbox') {
                    item.IsOtherArea = e.target.checked
                    if (!e.target.checked) {
                        item.ExhibitionOtherAreaID = ''
                    }
                } else if (type == 'varchar') {
                    item.Zone = e.target.value
                } else {
                    item.ExhibitionOtherAreaID = e.target.value
                }
            }
        })
        this.setState({ zoneList: zoneList })
    }

    handleClear(index) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                item.Zone = ''
            }
        })
        this.setState({ zoneList: zoneList })
    }

    handleRemove(index) {
        const { zoneList } = this.state
        zoneList.forEach((item, i) => {
            if (index == i) {
                item.ActionID = 3
            }
        })
        this.setState({ zoneList: zoneList })
    }

    render() {
        const { isLoading, exhibitionID, currentPage, gateMasterList, is_add, exhibitionList, gateName, zoneList, IsOtherArea, ExhibitionOtherAreaID, ExhibitionOtherAreaList, gateNameErr } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <p className="mb-0 p-2 text-white">Gate {is_add ? 'Add' : 'Update'}</p>
                            </div>
                        </div>
                        {/* <div className="app-content with-dr-container com-height"> */}
                        <div className="admin-top-space p-2">
                            {
                                JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                <div className="row p-2">
                                    <div className="col-md-4">
                                        <label>Gate Name <span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={gateName}
                                            onChange={(e) => this.setState({ gateName: e.target.value, })}
                                        />
                                        {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {gateNameErr}
                                            </span>
                                        }
                                    </div>
                                </div>
                            }
                            < div className="row mt-2" >
                                <div className="col-md-12">
                                    <div className="main-container container-fluid p-2 pt-0 pb-0">
                                        <div className="mt-1 mb-4">
                                            {
                                                sessionStorage.getItem("sessionExhRegistrationID") == null &&
                                                <button className="btn btn-aqua" onClick={e => this.onSave()}>
                                                    {" "}
                                                    Save{" "}
                                                </button>
                                            }

                                            <button className="btn btn-gray mx-2" onClick={e => this.onBack()} >
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* </div> */}
                    </div>
                </>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getGateMasterDetails_action, insertUpdateGateMaster_action })(GateMasterAU));